import * as React from 'react';
import { SearchQueryDateRange } from '@/types/search/searchQuery';
import isEqual from 'react-fast-compare';
import SearchFilterChips from '@/pages/Search/Components/SearchFilterChips';
import styled from 'styled-components';

export type FilterBarProps = {
    className?: string;
    distance: any;
    /**
     * Whether or not there are any filters applied to the current search
     */
    empty?: boolean;
    facetOptionChecked: (facetName: string, value: string, isChecked: boolean) => void;
    facets: any[];
    filterTerms: string[];
    publishDate: SearchQueryDateRange;
    ranges: any;
    removeCountryAndDistance?: (event?: any) => void;
    removeFacetById?: Function;
    removePublishedDate?: (event: any) => void;
    removeSaleDates?: (event: any) => void;
    saleDateMax?: number;
    saleDateMin?: number;
    selectedCreator?: string;
    showWithCategories?: boolean;
    taxonomyAllSelected?: Function;
    toggleFilterTerm?: Function;
};

const FilterBar = ({
    distance,
    empty,
    facetOptionChecked,
    facets,
    filterTerms,
    publishDate,
    ranges,
    removeCountryAndDistance,
    removeFacetById,
    removePublishedDate,
    removeSaleDates,
    saleDateMax,
    saleDateMin,
    selectedCreator,
    showWithCategories = false,
    taxonomyAllSelected,
    toggleFilterTerm,
}: FilterBarProps) => {
    if (empty) {
        return null;
    }

    return (
        <ChipsContainer>
            <SearchFilterChips
                distance={distance}
                facetOptionChecked={facetOptionChecked}
                facets={facets}
                filterTerms={filterTerms}
                publishDate={publishDate}
                ranges={ranges}
                removeCountryAndDistance={removeCountryAndDistance}
                removeFacetById={removeFacetById}
                removePublishedDate={removePublishedDate}
                removeSaleDates={removeSaleDates}
                saleDateMax={saleDateMax}
                saleDateMin={saleDateMin}
                selectedCreator={selectedCreator}
                showWithCategories={showWithCategories}
                taxonomyAllSelected={taxonomyAllSelected}
                toggleFilterTerm={toggleFilterTerm}
            />
        </ChipsContainer>
    );
};

export default React.memo<FilterBarProps>(FilterBar, isEqual);

const ChipsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
    max-height: 300px;

    div {
        margin-bottom: 15px;
    }
`;
